module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//blue_2.png?v=060b3626";